import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialRegistration = ({ onSocialRegister, loading }) => {
  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Mail',
      className: 'border-red-200 hover:border-red-300 hover:bg-red-50'
    },
    {
      id: 'linkedin_oidc',
      name: 'LinkedIn',
      icon: 'Linkedin',
      className: 'border-blue-200 hover:border-blue-300 hover:bg-blue-50'
    },
    {
      id: 'azure',
      name: 'Microsoft',
      icon: 'Mail',
      className: 'border-blue-200 hover:border-blue-300 hover:bg-blue-50'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-card text-muted-foreground">Or continue with</span>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            onClick={() => onSocialRegister(provider?.id)}
            disabled={loading}
            className={`w-full justify-center ${provider?.className}`}
          >
            <Icon name={provider?.icon} size={18} className="mr-2" />
            Continue with {provider?.name}
          </Button>
        ))}
      </div>
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          By continuing, you agree to our{' '}
          <a href="/terms" className="text-primary hover:underline">
            Terms of Service
          </a>{' '}
          and{' '}
          <a href="/privacy" className="text-primary hover:underline">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default SocialRegistration;